<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="group.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Статус</label>
            <crm-deal-status-single-select
              [(selectedStatus)]="group.status"
              [isError]="$any(errors?.status)"></crm-deal-status-single-select>
            <small
              *ngIf="errors?.status"
              class="p-error">
              {{ errors.status | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Сделки</label>
            <crm-deal-multi-select
              [(selectedDeals)]="group.deals"
              [isError]="$any(errors?.deals)"
              appendTo="body"></crm-deal-multi-select>
            <small
              *ngIf="errors?.deals"
              class="p-error">
              {{ errors.deals | join }}
            </small>
          </div>
        </div>
      </p-card>

      <p-card
        header="Аудиторы"
        styleClass="mt-3">
        <div class="formgrid grid">
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Пользователи</label>
            <crm-user-multi-select
              [(selectedUsers)]="group.userAuditors"
              [isFloatLabel]="false"
              appendTo="body"></crm-user-multi-select>
          </div>
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Группы</label>
            <crm-user-group-multi-select
              [(selectedUserGroups)]="group.groupAuditors"
              [isFloatLabel]="false"
              appendTo="body">
            </crm-user-group-multi-select>
          </div>
        </div>
      </p-card>

      <div
        *ngIf="formStoreService.getState.forms[this.index]?.isEdit"
        class="mt-3">
        <crm-deal-group-history [index]="index"></crm-deal-group-history>
      </div>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success mr-2"
        (onClick)="saveDealGroup()"></crm-button>
      <crm-button
        *ngIf="(form$ | async)?.isShowDelete"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteDealGroup()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
